import { render, staticRenderFns } from "./ImagesTabs.vue?vue&type=template&id=5e38f8e4&scoped=true&"
import script from "./ImagesTabs.vue?vue&type=script&lang=js&"
export * from "./ImagesTabs.vue?vue&type=script&lang=js&"
import style0 from "./ImagesTabs.vue?vue&type=style&index=0&id=5e38f8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38f8e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs})
